import * as React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { Icon, Table } from 'antd';

import { routeGenerator } from 'routes';
import Search from 'shared/components/Search/Search';

import s from './style/Groups.pcss';
import { editGroup, getGroupList } from './http';
import { isSupervisorUser } from '../../../Auth/redux/auth.redux';
import GroupEditor from './GroupList/GroupEditor';
import getUserId from '../../../shared/utils/getUserId';
import Loader from '../../../shared/components/Loader/Loader';


const columns = [
  {
    title: 'Название группы',
    dataIndex: 'name',
    width: '30%',
  },
  {
    title: 'Привязанные подразделения',
    dataIndex: 'units',
    width: '40%',
  },
  {
    title: 'Роли',
    dataIndex: 'roles',
    width: '40%',
  },
];


@connect(
  state => ({
    isSupervisor: isSupervisorUser(state),
  }),
)
export default class Groups extends React.Component {
  static propTypes = {
    isSupervisor: PropTypes.bool.isRequired,
    history: PropTypes.shape().isRequired,
  };

  componentWillMount() {
    this.loadGroups(this.props);
  }

  state = {
    loading: false,
    groups: [],
    addMode: false,
    filterBy: '',
  };

  componentDidMount() {
    this.setState({ loading: true }, () => {
      this.loadGroups().then((data) => {
        const groups = data.map((item) => {
          const unitArray = item.unitArray || [];
          const unitstr = unitArray.length > 2
            ? `${unitArray.filter((u, i) => i < 2).map(u => u.name).join(', ')} и еще ${unitArray.length - 2}`
            : (item.unitArray || []).map(u => u.name).join(', ');
          return {
            id: item.id,
            name: item.name,
            units: unitstr,
            roles: (item.roleArray || []).map(u => u.name).join(', '),
          };
        });
        this.setState({ groups, loading: false });
      });
    });
  }

  handleSearch = filterBy => this.setState({ filterBy });

  onEditMode = addMode => this.setState({ addMode });

  loadGroups = () => getGroupList(this.props.isSupervisor);

  onAddGroup = (id, groupName) => {
    const data = { name: groupName, createdByUserId: getUserId() };
    editGroup(data).then((group) => {
      this.setState({ groups: this.state.groups.concat(group) });
    });
  };

  onRowClick = item =>
    this.props.history.push(routeGenerator.groupRoleLink(item.id));

  render() {
    const { groups, addMode, filterBy } = this.state;
    const filteredData = groups
      .filter(item => (item.name || '').toLowerCase().includes(filterBy.toLowerCase()));

    const loading = {
      spinning: this.state.loading,
      indicator: <Loader fullScreen={false} size={20} />,
    };

    return (
      <div className={s.container}>
        <div className={s.header}>
          <div className={s.searchContainer}>
            <Search onSearch={this.handleSearch} value={filterBy} />
          </div>
          <div className={s.addContainer} onClick={this.onEditMode}>
            <Icon type="plus" theme="outlined" />
            <div className={s.addBtn}>Добавить группу</div>
          </div>
        </div>

        <div className={s.bodyContainer}>
          <Table
            rowKey={r => r.id}
            onRow={record => ({
              onClick: () => this.onRowClick(record),
            })}
            pagination={false}
            loading={loading}
            columns={columns}
            dataSource={filteredData}
            scroll={{ y: 'calc(100vh - 300px)' }}
          />
        </div>

        <GroupEditor
          visible={addMode}
          onClose={() => this.onEditMode(false)}
          onEdit={this.onAddGroup}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Root/pages/Groups/Groups.js